import Component from '@glimmer/component';
import PaperProgressCircular from 'ember-paper/components/paper-progress-circular';

interface LoadingSpinnerSignature {
  Args: {
    // loadingMessage configures the message to display while loading.
    loadingMessage?: string;
    // size configures the diameter of the loading spinner. The default is 80.
    size?: number;
    // page shows the spinner in the centre of the screen, for a route
    // `loading` template. Route outlets often have no height, so the spinner
    // cannot centre itself in them. The block is fixed to the viewport and
    // does not catch clicks, so the navigation stays usable while the page
    // loads.
    page?: boolean;
  };
  Blocks: { default: [] };
}

// LoadingSpinner shows a spinner in the centre of the element that holds it.
// ember-paper turns the spinner svg with a CSS animation, and the svg has
// overflow: visible. At 45 degrees its corners go out of the spinner block,
// so the root clips them (overflow-hidden). Without the clip, the page height
// changes as the spinner turns, and a scrollbar comes and goes (HE-386).
export default class LoadingSpinner extends Component<LoadingSpinnerSignature> {
  get size() {
    return this.args.size ?? 80;
  }

  <template>
    <div
      class="md-padding tw:box-border tw:flex tw:h-full tw:items-center tw:justify-center tw:overflow-hidden
        {{if @page 'tw:pointer-events-none tw:fixed tw:inset-0'}}"
    >
      <div
        class="tw:flex tw:flex-col tw:items-center tw:justify-center"
        data-test-loading-spinner
      >
        <PaperProgressCircular @accent={{false}} @diameter={{this.size}} />
        {{#if @loadingMessage}}
          <p data-test-loading-spinner-text>
            {{@loadingMessage}}
          </p>
        {{else if (has-block)}}
          {{yield}}
        {{/if}}
      </div>
    </div>
  </template>
}
